import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WdxTabActionsComponent } from './wdx-tab-actions/wdx-tab-actions.component';
import { WdxTabLinkActiveDirective } from './wdx-tab-link-active/wdx-tab-link.directive';
import { WdxTabLinkDirective } from './wdx-tab-link/wdx-tab-link.directive';
import { WdxTabDirective } from './wdx-tab/wdx-tab.directive';
import { WdxTabsComponent } from './wdx-tabs.component';

@NgModule({
    imports: [CommonModule],
    declarations: [
        WdxTabActionsComponent,
        WdxTabDirective,
        WdxTabLinkActiveDirective,
        WdxTabLinkDirective,
        WdxTabsComponent,
    ],
    exports: [
        WdxTabsComponent,
        WdxTabDirective,
        WdxTabLinkDirective,
        WdxTabLinkActiveDirective,
        WdxTabActionsComponent,
    ],
})
export class WdxTabsModule {}
